var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-card-base',[_c('div',{staticClass:"page-admin-estates-item-info-block"},[(_vm.title)?_c('h2',{staticClass:"page-admin-estates-item-info-block__title",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }